import { graphql } from "gatsby";
import type { PayloadService } from "../types/payload";
import type { ImageCard } from "./image/types";
import type { ServiceTypeData } from "./ServiceType";

export enum ServiceTypesPrefixesEnum {
  Roofer = "findARoofer",
  Branch = "findABranch",
  Merchant = "findAMerchant"
}

export type ServiceTypeFilter = Record<string, boolean>;

export type ServiceData = Pick<
  PayloadService,
  | "__typename"
  | "id"
  | "entryType"
  | "name"
  | "location"
  | "address"
  | "phone"
  | "email"
  | "website"
  | "facebook"
  | "twitter"
  | "instagram"
  | "linkedIn"
  | "websiteLinkAsLabel"
  | "fax"
  | "certification"
  | "summary"
> & {
  companyLogo: ImageCard | null;
  serviceTypes: ServiceTypeData[] | null;
};

export const query = graphql`
  fragment ServiceFragment on PayloadService {
    __typename
    id
    entryType
    name
    location
    address
    phone
    email
    website
    facebook
    twitter
    instagram
    linkedIn
    websiteLinkAsLabel
    companyLogo {
      ...ImageCardFragment
    }
    fax
    serviceTypes {
      ...ServiceTypeFragment
    }
    certification
    summary
  }
`;
